import React, { useContext, useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import "./SubscriptionModal.css";
import "../../../assets/css/modal.css";
import { dataContext } from "../../../App";
import activityLogSubmission from "../../../helper/activitylog";
import analyticEvent from "../../../helper/gaEvent";
const SubscriptionModal = ({
  showSubscriptionModal,
  setShowSubscriptionModal,
  searchParams,
  setSearchParams,
}) => {
  const { token, setToken, playerData, setPlayerData } =
    useContext(dataContext);

  const [notificationShown, setNotificationShown] = useState(false);

  function hideModalOperation() {
    setShowSubscriptionModal(false);
    searchParams.delete("status");
    setSearchParams(searchParams);
  }

  useEffect(() => {
    // let msisdn = null;
    // if (playerData?.id) {
    //   msisdn = playerData?.msisdn;
    // }
    // activityLogSubmission("contacts", msisdn);
    // analyticEvent('contact', 'contact-view')
  }, []);

  useEffect(() => {
    if (!playerData?.isSubscribe || !playerData?.isSubscribeTournament) {
      if (!notificationShown && Notification.permission === "granted") {
        navigator.serviceWorker.ready
          .then((registration) => {
            registration.showNotification("স্বাগতম Quizard এ!", {
              body: "সাবস্ক্রিপশন এর জন্য পাচ্ছেন ৫ টাকা ক্যাশ ইন পুরস্কার",
              icon: "https://ms.purplepatch.online/logo/quizard.png",
              requireInteraction: true,
              // actions: [
              //   {
              //     action: "redirect",
              //     title: "সাবস্ক্রাইব করুন",
              //     deepLink: "https://quizard.live/?page=subscription",
              //   },
              // ],
              data: {
                redirectPath: "https://quizard.live/?page=subscription",
              },
            });
            setNotificationShown(true);
          })
          .catch((error) => {
            console.error("Service Worker error:", error);
          });
      } else if (!notificationShown && Notification.permission !== "denied") {
        Notification.requestPermission().then((permission) => {
          if (permission === "granted") {
            navigator.serviceWorker.ready
              .then((registration) => {
                registration.showNotification("স্বাগতম Quizard এ!", {
                  body: "সাবস্ক্রিপশন এর জন্য পাচ্ছেন ৫ টাকা ক্যাশ ইন পুরস্কার",
                  icon: "https://ms.purplepatch.online/logo/quizard.png",
                  requireInteraction: true,
                  // actions: [
                  //   {
                  //     action: "redirect",
                  //     title: "সাবস্ক্রাইব করুন",
                  //     deepLink: "https://quizard.live/?page=subscription",
                  //   },
                  // ],
                  data: {
                    redirectPath: "https://quizard.live/?page=subscription",
                  },
                });
                setNotificationShown(true);
              })
              .catch((error) => {
                console.error("Service Worker error:", error);
              });
          }
        });
      }
    }
  }, [
    playerData?.isSubscribe,
    playerData?.isSubscribeTournament,
    notificationShown,
  ]);

  return (
    <>
      <Modal
        show={showSubscriptionModal}
        centered
        dialogClassName="modal-dialog"
        contentClassName="modalContent"
        onHide={hideModalOperation}
      >
        <Modal.Header closeButton>
          <Modal.Title>সাবস্ক্রিপশন</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <span className="modalSubsCustom">
            {" "}
            আপনি সফলভাবে সাবস্ক্রাইবড হয়েছেন।{" "}
          </span>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default SubscriptionModal;
